import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const constantRoutes = [
  {
    path: '/',
    redirect: '/dashboard/view',
  },
  {
    path: '/dashboard/view',
    mate: '整体概览',
    component: () => import('@/views/dashboard/view.vue'),
    hidden: true,
    hideHeader: true,
    subMenuType: 'button',
    permissions: ['dashboard:view'],
  },
  {
    path: '/dashboard/monitor',
    mate: '监控统计',
    component: () => import('@/views/dashboard/monitor.vue'),
    hidden: true,
    hideHeader: true,
    subMenuType: 'button',
    permissions: ['dashboard:monitor'],
  },
  {
    path: '/gps/map',
    mate: '地图模式',
    component: () => import('@/views/gps/map.vue'),
    hidden: false,
    permissions: ['dashboard:monitor'],
  },
  {
    path: '/gps/building',
    mate: '楼层模式',
    component: () => import('@/views/gps/building.vue'),
    hidden: false,
    permissions: ['dashboard:monitor'],
  },
  {
    path: '/warning/all',
    mate: '全部告警',
    component: () => import('@/views/warning/all.vue'),
    hidden: false,
    permissions: ['warning:all'],
  },
  {
    path: '/warning/level1',
    mate: '一级告警',
    component: () => import('@/views/warning/level1.vue'),
    hidden: false,
    permissions: ['warning:level1'],
  },
  {
    path: '/warning/level2',
    mate: '二级告警',
    component: () => import('@/views/warning/level2.vue'),
    hidden: false,
    permissions: ['warning:level2'],
  },
  {
    path: '/warning/level3',
    mate: '三级告警',
    component: () => import('@/views/warning/level3.vue'),
    hidden: false,
    permissions: ['warning:level3'],
  },
  {
    path: '/warning/remind',
    mate: '预警告警',
    component: () => import('@/views/warning/remind.vue'),
    hidden: false,
    permissions: ['warning:remind'],
  },
  {
    path: '/flow/template',
    mate: '流程管理',
    component: () => import('@/views/flow/template.vue'),
    hidden: false,
    permissions: ['flow:template:list'],
  },
  {
    path: '/flow/form',
    mate: '流程表单',
    component: () => import('@/views/flow/form.vue'),
    hidden: false,
    permissions: ['flow:template:list'],
  },
  {
    path: '/flow/conTypeConfig',
    mate: '工单类型配置',
    component: () => import('@/views/flow/conType/conTypeConfig.vue'),
    hidden: false,
    permissions: ['flow:template:list'],
  },
  {
    path: '/flow/sceneConfig',
    mate: '场景类型配置',
    component: () => import('@/views/flow/scene/sceneTypeConfig.vue'),
    hidden: false,
    permissions: ['flow:template:list'],
  },
  {
    path: '/flow/design',
    mate: '流程设计',
    component: () => import('@/views/flow/flowDesign.vue'),
    hidden: true,
    hideHeader: false,
    permissions: ['task:flowDemo'],
  },
  {
    path: '/flow/formGen',
    mate: '流程表单设计',
    component: () => import('@/views/flow/formGen.vue'),
    hidden: true,
    hideHeader: false,
    permissions: ['task:formGen'],
  },
  {
    path: '/item/index',
    mate: '事项列表',
    component: () => import('@/views/item/list.vue'),
    hidden: false,
    permissions: ['item:list'],
  },
  {
    path: '/item/add',
    mate: '新增事项',
    component: () => import('@/views/item/add.vue'),
    hidden: true,
    hideHeader: true,
    permissions: ['business:item:add'],
  },
  {
    path: '/item/process/detail',
    mate: '工单详情',
    component: () => import('@/views/item/flowDetail.vue'),
    hidden: true,
    hideHeader: true,
    permissions: ['business:item:detail'],
  },
  {
    path: '/item/todolist',
    mate: '我的待办',
    component: () => import('@/views/item/todoList.vue'),
    hidden: false,
    permissions: ['business:item:list'],
  },
  {
    path: '/production/list',
    mate: '产品列表',
    component: () => import('@/views/production/list.vue'),
    hidden: false,
    permissions: ['production:list'],
  },
  {
    path: '/production/tags',
    mate: '产品标签',
    component: () => import('@/views/production/tags.vue'),
    hidden: false,
    permissions: ['production:tags'],
  },
  {
    path: '/production/list/add',
    mate: '添加产品',
    component: () => import('@/views/production/add.vue'),
    hidden: true,
    hideHeader: true,
    permissions: ['production:add'],
  },
  {
    path: '/production/list/detail',
    mate: '产品详情',
    component: () => import('@/views/production/detail.vue'),
    hidden: true,
    hideHeader: true,
    permissions: ['production:detail'],
  },
  {
    path: '/production/authInfo',
    mate: '产品鉴权信息',
    component: () => import('@/views/production/authInfo.vue'),
    hidden: true,
    hideHeader: true,
    permissions: ['production:auth'],
  },
  {
    path: '/production/list/detail/editThingModel',
    mate: '编辑物模型',
    component: () => import('@/views/production/editThingModel.vue'),
    hidden: true,
    hideHeader: true,
    permissions: ['production:thing:model:edit'],
  },
  {
    path: '/device/list',
    mate: '设备列表',
    component: () => import('@/views/device/list.vue'),
    hidden: false,
    permissions: ['device:list'],
  },
  {
    path: '/device/video',
    mate: '视频列表',
    component: () => import('@/views/device/video.vue'),
    hidden: false,
    permissions: ['device:video'],
  },
  {
    path: '/device/videoControls',
    mate: '视频详情',
    component: () => import('@/views/device/videoControls.vue'),
    hidden: true,
    hideHeader: true,
    permissions: ['device:video'],
  },
  {
    path: '/device/list/detail',
    mate: '设备详情',
    component: () => import('@/views/device/detail.vue'),
    hidden: true,
    hideHeader: true, // 如果配置为true则整个页面全部自定义
    backText: '返回列表', // 如果不写的话就是默认的返回
    permissions: ['device:detail'],
  },
  {
    path: '/device/props/history',
    mate: '任务日志',
    component: () => import('@/views/device/components/detail/history-info'),
    hidden: true,
    hideHeader: false, // 如果配置为true则整个页面全部自定义
    permissions: ['device:detail:history'],
  },
  {
    path: '/device/tags',
    mate: '设备标签',
    component: () => import('@/views/device/tags.vue'),
    hidden: false,
    permissions: ['device:tags'],
  },
  {
    path: '/device/layout',
    mate: '布局管理',
    component: () => import('@/views/device/videoLayout.vue'),
    hidden: false,
    permissions: ['device:layout'],
  },
  {
    path: '/device/video/grid',
    mate: '视频墙',
    component: () => import('@/views/device/videoGrid.vue'),
    hidden: false,
    permissions: ['device:video:grid'],
  },
  {
    path: '/profile/index',
    mate: '事项管理',
    component: () => import('@/views/profile/index.vue'),
    hidden: false,
    permissions: ['profile:index'],
  },
  {
    path: '/global/users',
    mate: '人员管理',
    component: () => import('@/views/global/users.vue'),
    hidden: false,
    permissions: ['global:user:list'],
  },
  {
    path: '/global/dept',
    mate: '部门管理',
    component: () => import('@/views/global/dept.vue'),
    hidden: false,
    permissions: ['global:dept:list'],
  },
  {
    path: '/notice/index',
    mate: '通知管理',
    component: () => import('@/views/notice/index.vue'),
    hidden: false,
    permissions: ['notice:index'],
  },
  {
    path: '/notice/me',
    mate: '我的通知',
    component: () => import('@/views/notice/me.vue'),
    hidden: false,
    permissions: ['notice:me'],
  },
  {
    path: '/global/logIndex',
    mate: '日志管理',
    component: () => import('@/views/global/logIndex.vue'),
    hidden: false,
    permissions: ['log:index'],
  },
  {
    path: '/global/dict',
    mate: '数据字典',
    component: () => import('@/views/global/dict.vue'),
    hidden: false,
    permissions: ['global:dict'],
  },
  {
    path: '/global/dict/data',
    mate: '字典数据',
    component: () => import('@/views/global/dict/data.vue'),
    hidden: true,
    hideHeader: false, // 如果配置为true则整个页面全部自定义
    backText: '返回列表', // 如果不写的话就是默认的返回
    permissions: ['global:dict:data'],
  },
  {
    path: '/openapi/index',
    mate: '服务管理',
    component: () => import('@/views/openapi/index.vue'),
    hidden: false,
    permissions: ['openApi:list'],
  },
  {
    path: '/openapi/index/develop',
    mate: '在线调试',
    component: () => import('@/views/openapi/develop.vue'),
    hidden: true,
    hideHeader: false, // 如果配置为true则整个页面全部自定义
    backText: '返回列表', // 如果不写的话就是默认的返回
    permissions: ['openApi:dev'],
  },
  {
    path: '/openapi/applyinfo',
    mate: '申请记录',
    component: () => import('@/views/openapi/applyinfo.vue'),
    hidden: false,
    permissions: ['openApi:applyinfo'],
  },
  {
    path: '/openapi/check',
    mate: '审批记录',
    component: () => import('@/views/openapi/check.vue'),
    hidden: false,
    permissions: ['openApi:check'],
  },
  {
    path: '/openapi/apidoc',
    mate: '审批记录',
    component: () => import('@/views/openapi/apidoc.vue'),
    hidden: false,
    permissions: ['openApi:check'],
  },
  {
    path: '/rule/index',
    mate: '设备联动',
    component: () => import('@/views/rule/index.vue'),
    hidden: false,
    permissions: ['rule:index:list'],
  },
  {
    path: '/rule/index/configs',
    mate: '规则配置',
    component: () => import('@/views/rule/configs.vue'),
    hidden: false,
    permissions: ['rule:index:list'],
  },
  {
    path: '/webapp/applist',
    mate: '应用列表',
    component: () => import('@/views/webapp/applist.vue'),
    hidden: true,
    hideHeader: true,
    subMenuType: 'button',
    permissions: ['webapp:applist'],
  },
  {
    path: '/webapp/applyinfo',
    mate: '我的申请',
    component: () => import('@/views/webapp/applyinfo.vue'),
    hidden: true,
    hideHeader: true,
    subMenuType: 'button',
    permissions: ['webapp:applyinfo'],
  },
  {
    path: '/webapp/check',
    mate: '申请记录',
    component: () => import('@/views/webapp/check.vue'),
    hidden: true,
    hideHeader: true,
    subMenuType: 'button',
    permissions: ['webapp:check'],
  },
  {
    path: '/webapp/energy/index',
    mate: '能耗管理',
    component: () => import('@/views/webapp/energy/index.vue'),
    hidden: true,
    hideHeader: true, // 如果配置为true则整个页面全部自定义
    defineContent: true,
    backText: '返回应用列表', // 如果不写的话就是默认的返回
    permissions: ['webapp:energy:index'],
  },
  {
    path: '/webapp/light/index',
    mate: '灯控管理',
    component: () => import('@/views/webapp/light/index.vue'),
    hidden: true,
    hideHeader: true, // 如果配置为true则整个页面全部自定义
    defineContent: true,
    backText: '返回应用列表', // 如果不写的话就是默认的返回
    permissions: ['webapp:light:index'],
  },
  {
    path: '/webapp/room/index',
    mate: '实验室管理',
    component: () => import('@/views/webapp/room/index.vue'),
    hidden: true,
    hideHeader: false, // 如果配置为true则整个页面全部自定义
    backText: '返回应用列表', // 如果不写的话就是默认的返回
    permissions: ['webapp:room:index'],
  },
  {
    path: '/webapp/parking/index',
    mate: '停车场管理',
    component: () => import('@/views/webapp/park/index.vue'),
    hidden: true,
    hideHeader: true, // 如果配置为true则整个页面全部自定义
    defineContent: true,
    backText: '返回应用列表', // 如果不写的话就是默认的返回
    permissions: ['webapp:park:index'],
  },
  {
    path: '/webapp/walkGate/index',
    mate: '人行道闸',
    component: () => import('@/views/webapp/walkGate/index.vue'),
    hidden: true,
    hideHeader: true, // 如果配置为true则整个页面全部自定义
    defineContent: true,
    backText: '返回应用列表', // 如果不写的话就是默认的返回
    permissions: ['webapp:energy:index'],
  },
  {
    path: '/webapp/light/jobLog',
    mate: '任务日志',
    component: () => import('@/views/webapp/light/components/jobLog.vue'),
    hidden: true,
    hideHeader: false, // 如果配置为true则整个页面全部自定义
    backText: '返回灯控管理', // 如果不写的话就是默认的返回
    permissions: ['webapp:light:jobLog'],
  },
  {
    path: '/webapp/space/index',
    mate: '空间管理',
    component: () => import('@/views/webapp/space/index.vue'),
    hidden: true,
    hideHeader: false, // 如果配置为true则整个页面全部自定义
    backText: '返回应用列表', // 如果不写的话就是默认的返回
    permissions: ['webapp:space:index'],
  },
  {
    path: '/inspection/area',
    mate: '巡检区域',
    component: () => import('@/views/inspection/area.vue'),
    hidden: false,
    permissions: ['inspection:area'],
  },
  {
    path: '/inspection/areaSite',
    mate: '巡检点',
    component: () => import('@/views/inspection/areaSite.vue'),
    hidden: false,
    permissions: ['inspection:areaSite'],
  },
  {
    path: '/inspection/route',
    mate: '巡检线路',
    component: () => import('@/views/inspection/route.vue'),
    hidden: false,
    permissions: ['inspection:route'],
  },
  {
    path: '/inspection/plan',
    mate: '巡检计划',
    component: () => import('@/views/inspection/plan.vue'),
    hidden: false,
    permissions: ['inspection:plan'],
  },
  {
    path: '/inspection/project',
    mate: '巡检任务',
    component: () => import('@/views/inspection/project.vue'),
    hidden: false,
    permissions: ['inspection:project'],
  },
  {
    path: '/inspection/order',
    mate: '巡检工单',
    component: () => import('@/views/inspection/order.vue'),
    hidden: false,
    permissions: ['inspection:order'],
  },
  {
    path: '/light/device',
    mate: '灯控设备管理',
    component: () => import('@/views/light/device.vue'),
    hidden: false,
    permissions: ['light:device'],
  },
  {
    path: '/light/deviceRole',
    mate: '灯控设备权限',
    component: () => import('@/views/light/deviceRole.vue'),
    hidden: false,
    permissions: ['light:deviceRole'],
  },
  // {
  //   path: '/energy/overview',
  //   mate: '能耗总览',
  //   component: () => import("@/views/energy/overview.vue"),
  //   hidden: false,
  //   permissions: ['energy:overview']
  // },
  // {
  //   path: '/energy/usage',
  //   mate: '能耗用量',
  //   component: () => import("@/views/energy/usage.vue"),
  //   hidden: false,
  //   permissions: ['energy:usage']
  // },
  // {
  //   path: '/energy/sort',
  //   mate: '能耗排行',
  //   component: () => import("@/views/energy/sort.vue"),
  //   hidden: false,
  //   permissions: ['energy:sort']
  // },
  // {
  //   path: '/energy/enter',
  //   mate: '手动录入',
  //   component: () => import("@/views/energy/enter.vue"),
  //   hidden: false,
  //   permissions: ['energy:enter']
  // },
  // {
  //   path: '/energy/chargePlan',
  //   mate: '计费方案配置',
  //   component: () => import("@/views/energy/chargePlan.vue"),
  //   hidden: false,
  //   permissions: ['energy:chargePlan']
  // },
  {
    path: '/global/roleIndex',
    mate: '角色管理',
    component: () => import('@/views/global/roleIndex.vue'),
    hidden: false,
    permissions: ['system:role'],
  },
  {
    path: '/global/orgIndex',
    mate: '机构管理',
    component: () => import('@/views/global/orgIndex.vue'),
    hidden: false,
    permissions: ['organization:index'],
  },
  {
    path: '/global/menuIndex',
    mate: '菜单管理',
    component: () => import('@/views/global/menuIndex.vue'),
    hidden: false,
    permissions: ['system:menu'],
  },
  {
    path: '/404',
    mate: '页面不存在',
    component: () => import('@/views/404.vue'),
    hidden: false,
  },
  {
    path: '/login',
    mate: '登录',
    component: () => import('@/views/login.vue'),
  },
]

const router = new Router({
  mode: 'history', // 去掉url中的#
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes,
})

router.beforeEach((to, form, next) => {
  if (to.path !== '/login' && to.path !== '/404') {
    const token = localStorage.getItem('token')
    if (!token) {
      router.push('/login')
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
